import { MessageTypes } from '../constants';

export const cancelledCode = 907;
export const errorFieldsCode = 103;
export const invalidDocumentCode = 201;

export interface ErrorInfo {
  level: MessageTypes;
  keyMessage: string;
  title?: string;
  code?: number;
  showInside?: boolean;
  icon?: string;
  default?: ErrorInfo;
}

export interface ErrorCodes {
  [key: number | string]: ErrorInfo;
}
[];

export const errorCodes: ErrorCodes = {
  GENERIC_ERROR: {
    level: MessageTypes.ERROR,
    title: 'common.error.title',
    keyMessage: 'common.error.message',
  },
  [errorFieldsCode]: {
    code: errorFieldsCode,
    showInside: true,
    level: MessageTypes.ERROR,
    title: 'common.error.title',
    keyMessage: 'common.error.message',
  },
  [invalidDocumentCode]: {
    code: invalidDocumentCode,
    showInside: true,
    level: MessageTypes.ERROR,
    title: 'common.error.title',
    keyMessage: 'common.error.message',
  },
  403: {
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.paymentMethodDisabled.message',
  },
  404: {
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.paymentMethodNotSupported.message',
  },
  405: {
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.paymentMethodCountry.message',
  },
  803: {
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.processPayment.message',
  },
  806: {
    showInside: true,
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.rejectedByBank',
  },
  807: {
    showInside: true,
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.insufficientAmount',
  },
  808: {
    showInside: true,
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.invalidCard',
  },
  809: {
    showInside: true,
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.tryAgainLater',
  },
  810: {
    showInside: true,
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.callBank',
  },
  813: {
    showInside: true,
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.invalidCardNumber',
  },
  814: {
    showInside: true,
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.invalidSecurityCode',
  },
  905: {
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.invalidToken.message',
  },
  906: {
    icon: 'expired',
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.paymentExpired.message',
  },
  [cancelledCode]: {
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.paymentCanceled.message',
  },
  908: {
    level: MessageTypes.ERROR,
    keyMessage: 'common.errorCode.paymentCompleted.message',
  },
};
